/* Exporting patient profile default object. */
export default {
  profileData: [],
};
